import GameBoard, { GameBoardPlayer } from '@/src/components/GameBoard';

// Students render as wizard sprites rather than photos: it reads as a
// playful class roster and avoids implying real student photos.
const students: GameBoardPlayer[] = [
  { id: 'maya', name: 'Maya', src: '/wizard-avatars/sapphire.png', fit: 'contain', tile: 7 },
  { id: 'leo', name: 'Leo', src: '/wizard-avatars/frost.png', fit: 'contain', tile: 11 },
  { id: 'priya', name: 'Priya', src: '/wizard-avatars/amethyst.png', fit: 'contain', tile: 6 },
  { id: 'sam', name: 'Sam', src: '/wizard-avatars/sol.png', fit: 'contain', tile: 4 },
  { id: 'zoe', name: 'Zoe', src: '/wizard-avatars/sprout.png', fit: 'contain', tile: 3 },
  { id: 'omar', name: 'Omar', src: '/wizard-avatars/storm.png', fit: 'contain', tile: 2 },
  { id: 'ava', name: 'Ava', src: '/wizard-avatars/ember.png', fit: 'contain', tile: 1 },
];

export default function ClassroomGameBoard() {
  return (
    <GameBoard
      youId="maya"
      players={students}
      headerName="Maya R."
      annotation="Friday review race"
    />
  );
}
